import FieldWrapper from '@cohort/merchants/components/campaigns/preview/FieldWrapper';
import React from 'react';
import type {UseFormRegisterReturn} from 'react-hook-form';

type DefaultTextArea = JSX.IntrinsicElements['textarea'];

type TextAreaProps = {
  width?: string;
  testId?: string;
  register?: UseFormRegisterReturn;
  label?: string;
  mandatory?: boolean;
  error?: JSX.Element;
} & DefaultTextArea;

export const TextAreaInputPreview: React.FC<TextAreaProps> = ({
  testId,
  register,
  label,
  mandatory,
  width,
  error,
  className,
  ...props
}) => (
  <FieldWrapper className={width} label={label} mandatory={mandatory} error={error}>
    <textarea
      data-testid={testId}
      {...props}
      {...register}
      className="duration-50 block w-full resize-none rounded-md bg-[--xps-input-background-color] transition ease-in-out [border-color:--xps-input-border-color] focus:ring-2 focus:ring-[--xps-input-active-border-color] focus:[border-color:--xps-input-active-border-color] sm:text-sm"
      style={{
        borderRadius: 'var(--xps-input-border-radius)',
      }}
      rows={5}
    />
  </FieldWrapper>
);

TextAreaInputPreview.displayName = 'TextArea';
